import { render, staticRenderFns } from "./genderGraph.vue?vue&type=template&id=a2f53b74"
import script from "./genderGraph.vue?vue&type=script&lang=js"
export * from "./genderGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports